import { createSelector } from "@reduxjs/toolkit";

export const getAgents = createSelector(
    (store) => store.agents.data,
    (data) => data
);